const self = {
    getQuery: (params) => {
        return Object.keys(params).length !== 0 ? new URLSearchParams(params).toString() : ""
    },
    makeUrl: (key, version, path, query) => {
        const prefix = key + version + path
        return query
            ? `${prefix}?${self.getQuery(query)}`
            : prefix
    },
    toCamelCase: (snakeKey) => {
        if (self.isCamelCaseKey(snakeKey)) {
            return snakeKey
        }
        else {
            return snakeKey
                .toLowerCase()
                .split('_')
                .map((word, index) => index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1))
                .join('')
        }
    },
    isCamelCaseKey(key) {
        const camelCaseRegex = /^[a-z]+([A-Z][a-z0-9]*)*$/
        return camelCaseRegex.test(key)
    },
    dataFormatter: (obj) => {
        if (Array.isArray(obj)) {
            return obj.map(self.dataFormatter)
        }
        else if (obj !== null && typeof obj === "object") {
            return Object.fromEntries(
                Object.entries(obj).map(([key, value]) => [
                    self.toCamelCase(key),
                    self.dataFormatter(value)
                ])
            )
        }
        else {
            return obj
        }
    },
    toSnakeCase: (camelKey) => {
        return camelKey
            .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
            .toUpperCase()
    },
    paramFormatter: (obj) => {
        if (Array.isArray(obj)) {
            return obj.map(self.paramFormatter)
        }
        else if (obj !== null && typeof obj === "object") {
            if (obj instanceof File) {
                return obj
            }
            else {
                return Object.fromEntries(
                    Object.entries(obj).map(([key, value]) => [
                        self.toSnakeCase(key),
                        self.paramFormatter(value)
                    ])
                )
            }
        }
        else {
            return obj
        }
    },
    paramToFormData: (obj) => {
        const formData = new FormData()
        Object.entries(obj).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(el => {
                    formData.append(key, el)
                })
            }
            else if (typeof value === "object") {
                if (value instanceof File) {
                    formData.append(key, value)
                }
                else {
                    formData.append(key, JSON.stringify(value))
                }
            }
            else {
                formData.append(key, value)
            }
        })
        
        return formData
    },
    removeNullValues: (payload) => {
        const params = {}
        if (payload) {
            Object.keys(payload)
                .map(key => {
                    if (payload[key]) {
                        params[key] = payload[key]
                    }
                })
        }
        
        return params
    },
    getResponseData(response) {
        if (response) {
            if (response.status === 200 || response.status === 201) {
                return response.data
            } else {
                return response.data.errors
            }
        }
        else {
            return null
        }
    }
}

export default self